import Head from 'expo-router/head';
import { useState } from 'react';
import { ScrollView } from 'react-native';
import { getTokenValue, YStack } from 'tamagui';

import PSCouponCodeInput from '@/components/PSCouponCodeInput';
import PSText from '@/components/ui/PSText';

const VALID_CODE = 'PS10';

function LivePreview() {
  const [code, setCode] = useState('');
  const [appliedCode, setAppliedCode] = useState<string>();
  const [redeeming, setRedeeming] = useState(false);
  const [error, setError] = useState<string>();

  return (
    <PSCouponCodeInput
      code={code}
      appliedCode={appliedCode}
      redeeming={redeeming}
      error={error}
      onRedeem={(code) => {
        setRedeeming(true);
        setTimeout(() => {
          setRedeeming(false);
          if (code === VALID_CODE) {
            setAppliedCode(code);
            setCode('');
          } else setError('This coupon code is invalid.');
        }, 1000);
      }}
      onRemove={() => setAppliedCode(undefined)}
      onChangeCode={(next) => {
        setCode(next);
        setError(undefined);
      }}
    />
  );
}

const STATIC_PREVIEWS: {
  id: string;
  label: string;
  props: Partial<React.ComponentProps<typeof PSCouponCodeInput>>;
}[] = [
  { id: 'empty', label: 'Empty — Redeem disabled', props: {} },
  {
    id: 'typed',
    label: 'Typed, not yet redeemed',
    props: { code: 'EARLYBIRD' },
  },
  {
    id: 'redeeming',
    label: 'Redeeming — field locked, button spins',
    props: { redeeming: true },
  },
  {
    id: 'error',
    label: 'Server rejected the code',
    props: { error: 'This coupon code has expired.' },
  },
  {
    id: 'applied',
    label: 'Applied (e.g. resumed booking) — field + Redeem locked',
    props: { appliedCode: 'EARLYBIRD' },
  },
  {
    id: 'applied-long',
    label: 'Applied, long code',
    props: { appliedCode: 'PUTTINGSCENEWINTERFESTIVAL2026' },
  },
];

export default function PSCouponCodeInputPreview() {
  return (
    <>
      <Head>
        <title>PSCouponCodeInput · Putting Scene</title>
      </Head>
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: getTokenValue('$color.background', 'color'),
        }}
      >
        <YStack gap="$lg" p="$lg">
          <YStack gap="$xs">
            <PSText.Body3 color="$textDarkMuted">
              {`Live — "${VALID_CODE}" applies, anything else errors`}
            </PSText.Body3>
            <LivePreview />
          </YStack>
          {STATIC_PREVIEWS.map((preview) => (
            <YStack key={preview.id} gap="$xs">
              <PSText.Body3 color="$textDarkMuted">
                {preview.label}
              </PSText.Body3>
              <PSCouponCodeInput
                code=""
                onRedeem={() => {}}
                onRemove={() => {}}
                onChangeCode={() => {}}
                {...preview.props}
              />
            </YStack>
          ))}
        </YStack>
      </ScrollView>
    </>
  );
}
